// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//data:
import shortNamesList from '../../database/articles_short_names.json'
import { appURL } from '../../config/api-config';

//MUI
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';

//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

console.log(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)


function ligneTotauxJours({ contrats, sens, dateRef }) {


    let joursSemaine = [];

    for (let i = 0; i < 7; i++) {
        joursSemaine.push(dayjs(dateRef).weekday(i));
    }


    function getSorties(jour) {
        let contratsSorties = contrats.filter((contrat) => dayjs(contrat.date1).isSame(dayjs(jour), "day"));
        let listArtSorties = [];
        contratsSorties.forEach(contrat => {
            contrat.ContratArticles.forEach((art) => {
                for (let i = 1; i <= art.qte; i++) {
                    listArtSorties.push(art.article_id);
                }
            })
        })

        return listArtSorties
    }
    function getRetours(jour) {
        let contratsRetours = contrats.filter((contrat) => dayjs(contrat.date2).isSame(dayjs(jour), "day"));
        let listArtRetours = [];
        contratsRetours.forEach(contrat => {
            contrat.ContratArticles.forEach((art) => {
                for (let i = 1; i <= art.qte; i++) {
                    listArtRetours.push(art.article_id);
                }
            })
        })
        return listArtRetours
    }

    function showDetails(list) {
        if (list.length > 0) {
            let infos = " ";
            shortNamesList.forEach((art) => {
                if (list.filter((a) => (a === art.id_article)).length > 0) {
                    infos += "- " + list.filter(a => a === art.id_article).length + " x " + art.label
                }

            });

            alert(infos)
        }
    }
    /*  <div className="ligne-total">
             <div className="ligne-total-intro">
                 <p>{sens === "sorties" ? <UploadIcon /> : <DownloadIcon />}{sens} vélos</p>
 
             </div>
             <div className="ligne-total-cumul">
                 <p>Total : {sens === "sorties" ? listArtSorties.length : listArtRetours.length}</p>
 
             </div>
             <div className="ligne-total-details">
 
                 {sens === "sorties" ?
                     shortNamesList.map((art) => (
                         listArtSorties.filter((a) => (a === art.id_article)).length > 0 ?
                             <p>
                                 <span>{listArtSorties.filter(a => a === art.id_article).length}</span>
                                 {art.label}
                             </p>
                             : null
                     ))
                     :
                     shortNamesList.map((art) => (
                         listArtRetours.filter((a) => (a === art.id_article)).length > 0 ?
                             <p>
                                 <span>{listArtRetours.filter(a => a === art.id_article).length}</span>
                                 {art.label}
                             </p>
                             : null
                     ))
                 }
 
                 <p>&nbsp;</p>
             </div>
         </div> */

    return (


        <div className="ligne-contrat" style={{ margin: "auto" }}>
            <div className="ligne-contrat-nom">

            </div>
            <div className="ligne-semaine-jour">
                {joursSemaine.map(j => (
                    <div className="ligne-semaine-jour-totaux">
                        <span>
                            <p onClick={_ => showDetails(getSorties(j))}>{getSorties(j).length}<UploadIcon /></p>
                            <p onClick={_ => showDetails(getRetours(j))}><DownloadIcon />{getRetours(j).length}</p>
                        </span>
                    </div>
                ))}

            </div>
        </div>
    );
}

export default ligneTotauxJours